export const BASE_PADDING = 8
export const LEVEL_PADDING = 14
export const GROUP_PAGE_SIZE = 96

export function getItemPadding(level: number) {
  return BASE_PADDING + level * LEVEL_PADDING
}

export function getGuideOffset(level: number) {
  return BASE_PADDING + level * LEVEL_PADDING + 10
}
